import React, { useEffect, useState } from 'react';
import './CharCounter.css'

const CharCounter = () => {

    const [charCount, setCharCount] = useState(0);
    const [wordCount, setWordCount] = useState(0);
    const [spaceCount, setSpaceCount] = useState(0);
    const [enteredChar, setEnteredChar] = useState('');
    const [enteredContent, setEnteredContent] = useState('');
    const [caseSensitiveCount, setCaseSensitiveCount] = useState(0);
    const [caseInSensitiveCount, setCaseInSensitiveCount] = useState(0);

    const handleChange = (event) => {
        const value = event.target.value;
        const charCountLength = value.length;
        const wordCountLength = value.trim() === "" ? 0 : value.trim().split(/\s+/).length;
        const spacesLength = value.split(" ").length - 1;
        setCharCount(charCountLength);
        setWordCount(wordCountLength);
        setSpaceCount(spacesLength);
        setEnteredContent(value);
        
        // Update search results if there's a search term
        if (enteredChar && value) {
            updateSearchResults(enteredChar, value);
        }
    }

    const checkCount = (event) => {
        const value = event.target.value;
        setEnteredChar(value);
        
        if (value && enteredContent) {
            updateSearchResults(value, enteredContent);
        } else {
            setCaseSensitiveCount(0);
            setCaseInSensitiveCount(0);
        }
    }

    const updateSearchResults = (searchTerm, content) => {
        if (!searchTerm || !content) {
            setCaseSensitiveCount(0);
            setCaseInSensitiveCount(0);
            return;
        }
        
        const caseSensitiveCount = content.split(searchTerm).length - 1;
        setCaseSensitiveCount(caseSensitiveCount);
        const caseInsensitiveCount = content.toLowerCase().split(searchTerm.toLowerCase()).length - 1;
        setCaseInSensitiveCount(caseInsensitiveCount);
    }

    return (
        <div className='char-counter-container'>
            <h1 className='char-counter-header'>🔢 Character Counter</h1>
            
            <div className='char-counter-main-content'>
                <textarea 
                    className='char-counter-textarea' 
                    placeholder='Start typing your content here... ✍️'
                    onChange={handleChange}
                    maxLength={10000}
                />
                
                <div className='default-char-counter-results'>
                    <div className='default-char-counter-result'>
                        <span className='result-number'>{charCount}</span>
                        <span className='result-label'>Characters</span>
                    </div>
                    <div className='default-char-counter-result'>
                        <span className='result-number'>{wordCount}</span>
                        <span className='result-label'>Words</span>
                    </div>
                    <div className='default-char-counter-result'>
                        <span className='result-number'>{spaceCount}</span>
                        <span className='result-label'>Spaces</span>
                    </div>
                </div>
                
                <div className='char-counter-finder-wrapper'>
                    <label className='finder-label'>🔍 Search for specific text:</label>
                    <textarea 
                        className='char-counter-finder' 
                        placeholder='Type text to search within your content...'
                        onChange={checkCount}
                        value={enteredChar}
                    />
                </div>
                
                <div className='char-counter-result-wrapper'>
                    {enteredChar && enteredContent ? (
                        <>
                            <div className='char-counter-result'>
                                📊 <b>{caseSensitiveCount}</b> exact matches found (case-sensitive)
                            </div>
                            <div className='char-counter-result'>
                                🎯 <b>{caseInSensitiveCount}</b> matches found (case-insensitive)
                            </div>
                        </>
                    ) : enteredChar ? (
                        <div className='char-counter-result'>
                            ⚠️ No content to search in. Please add some text above first.
                        </div>
                    ) : enteredContent ? (
                        <div className='empty-state'>
                            <div className='empty-state-icon'>🔍</div>
                            Enter text in the search box above to find matches in your content
                        </div>
                    ) : (
                        <div className='empty-state'>
                            <div className='empty-state-icon'>📝</div>
                            Start typing in the text area above to see character count and search functionality
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default CharCounter